
import { css } from 'lit';
export default css`
.hf-search-filter-group {

  border-bottom-width: 1px;

  --tw-border-opacity: 1;

  border-color: rgba(164, 167, 171, var(--tw-border-opacity));
}

  .hf-search-filter-group--title {

  font-family: Lato, sans-serif
}

  .hf-search-filter-group--title {

  font-size: 1.375rem
}

  .hf-search-filter-group--icon {

  margin-left: 0.5rem
}

  .hf-search-filter-group--icon {

  height: 1.25rem
}

  .hf-search-filter-group--icon {

  width: 1.25rem
}

  .hf-search-filter-group--icon {

  --tw-text-opacity: 1;

  color: rgba(107, 31, 153, var(--tw-text-opacity))
}

  .hf-search-filter-group--toggle {

  display: flex
}

  .hf-search-filter-group--toggle {

  cursor: pointer
}

  .hf-search-filter-group--toggle {

  flex-wrap: wrap
}

  .hf-search-filter-group--toggle {

  align-items: center
}

  .hf-search-filter-group--toggle {

  justify-content: space-between
}

  .hf-search-filter-group--toggle {

  padding-top: 1.5rem;

  padding-bottom: 1.5rem
}

  .hf-search-filter-group--toggle {

  padding-right: 1.25rem
}

  .hf-search-filter-group--toggle:hover {

  --tw-text-opacity: 1;

  color: rgba(53, 25, 108, var(--tw-text-opacity))
}

  .hf-search-filter-group--toggle:hover .hf-search-filter-group--icon {

  --tw-text-opacity: 1;

  color: rgba(53, 25, 108, var(--tw-text-opacity))
}

  .hf-search-filter-group--items {

  padding-bottom: 1.5rem
}

  .hf-search-filter-group--items--closed {

  display: none
}

  .hf-search-filter-group--item {

  overflow-wrap: break-word
}

  .hf-search-filter-group--item {

  line-height: 2.5rem
}
`;